import type {
  OnDragEndResponder} from '@hello-pangea/dnd';
import {
  DragDropContext,
  Droppable
} from '@hello-pangea/dnd';
import * as React from 'react';
import type {
  DraggableListItemContent} from './DraggableListItem';
import {
  DraggableListItem
} from './DraggableListItem';

export interface DraggableListProps {
  items: DraggableListItemContent[];
  selectedIndex?: number;
  disabled?: boolean;
  onDragEnd: OnDragEndResponder;
  onSelect: (itemId: string) => void;
  onDelete: (itemId: string) => void;
  onMoveUp?: (itemId: string) => void;
  onMoveDown?: (itemId: string) => void;
}

export const DraggableList = React.memo<DraggableListProps>(
  ({items, selectedIndex, disabled, onDragEnd, onSelect, onDelete, onMoveUp, onMoveDown}) => {
    return (
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable-list" isDropDisabled={disabled}>
          {provided => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              role="listbox"
              aria-label="Field list">
              {items.map((item, index) => (
                <DraggableListItem
                  key={item.id}
                  content={item}
                  index={index}
                  selected={index === selectedIndex}
                  disabled={disabled}
                  onSelect={onSelect}
                  onDelete={onDelete}
                  onMoveUp={onMoveUp}
                  onMoveDown={onMoveDown}
                  isFirst={index === 0}
                  isLast={index === items.length - 1}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
);
